<div id="LoaderService" *ngIf="LoaderService">
	<span class="spinner-border spinner-grow-lg"></span>
</div>
<div class="modal fade" id="seasonEventDialog" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">
	<div class="modal-dialog modal-lg modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="linkClose()"></button>
			</div>
			<div class="container">
				<div class="input-group mb-6">
					<label class="form-label">Połączenie z sezonem</label>
				</div>
				<div class="input-group mb-6">
					<div class="input-group mb-3">
						<input
							type="text"
							class="form-control"
							name="season"
							[(ngModel)]="season"
							placeholder="ID sezonu"
						/>

						<button class="btn btn-primary" type="button" (click)="linkSave()">Połącz</button>
					</div>
				</div>

				<div class="col-11">
					<div
						class="input-group mb-6"
						data-toggle="tooltip"
						title="	https://www.youtube.com/watch?v=d3sQaJhfXnQ"
					>
						<label class="form-label">Liczba załogi</label>
						<div class="icon ps-2">
							<i class="fas fa-info-circle"></i>
						</div>
						Info : https://www.youtube.com/watch?v=d3sQaJhfXnQ
					</div>
					<div class="input-group mb-3">
						<input
							type="number"
							step="1"
							min="0"
							class="form-control"
							name="countCrewToSeason"
							[(ngModel)]="count"
							placeholder="Liczba załogi"
						/>

						<button class="btn btn-primary" type="button" (click)="crewSave()">Zmień</button>
					</div>
				</div>

				<table class="table table-striped table-hover">
					<thead class="table-dark">
						<tr>
							<th class="align-middle">Season</th>
							<th class="align-middle">Nazwa</th>
							<th class="align-middle">Wyjazd</th>
							<th class="align-middle">Powrót</th>
							<th class="align-middle">Typ</th>
							<th class="align-middle"></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let item of data">
							<td>
								{{ item.seasonId }}
							</td>
							<td>
								{{ item.name }}
							</td>
							<td>
								{{ item.departure }}
							</td>
							<td>
								{{ item.return }}
							</td>
							<td>
								<select
									type="text"
									class="form-select"
									name="kind"
									[(ngModel)]="item.kind"
									(change)="save(item)"
								>
									<option [value]="item.idKind" *ngFor="let item of kind">
										{{ item.name }}
									</option>
								</select>
							</td>
							<td>
								<button class="btn btn-primary" (click)="deleteAsk(item)">Usuń</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>
